<template>
  <div id="app">
    <!-- 由匹配到的组件，将渲染到这个标签里 -->


    <router-view/>
<!-- 这里是简写，原代码应该为<router-view></router-view> -->
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
::-webkit-scrollbar{display:none;}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  max-width:750px;
  margin-left:auto;
  margin-right:auto;


}
body{
  margin:0;
  overflow-y:scroll;
  background-color: #FFFFFF;
}
input{
  /* border:none!important; */
  background-color: transparent;
}
.el-button--success{
  background-color: var(--theme-color)!important;
  border-color: var(--theme-color)!important;
}
.el-dialog__body{
  text-align: center!important;
}
:root{
  --theme-color:#b22830;

}

input::-webkit-input-placeholder {
	/* WebKit browsers，webkit内核浏览器 */
	color: #c8c7ce;
}
input:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
	color: #c8c7ce;
}
input::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	color: #c8c7ce;
}
input:-ms-input-placeholder {
	/* Internet Explorer 10+ */
	color: #c8c7ce;
}
</style>



// WEBPACK FOOTER //
// src/App.vue